import { IJsonapiModel, Response } from 'datx-jsonapi';

import { ListResponse } from '@/lib/datx-jsonapi-react/interfaces/ListResponse';

interface IWithId {
  id: number | string;
}
export function findModelInPages<TModel extends IJsonapiModel & IWithId>(
  pages: Array<Response<TModel>> | Array<ListResponse<TModel>>,
  id: string | number
) {
  let match;

  for (let i = 0; i < pages.length; i++) {
    const response = pages[i];

    match = (response.data as Array<TModel>).find((model) => model.id === id);

    if (match) {
      break;
    }
  }

  return match;
}
